import { createSlice } from '@reduxjs/toolkit';
const initState = {
  transaction_id: '',
  quote_id: '',
  label: '',
  businessType: '', // 1: new, 2: rollover, 3: renewal
  stage: 0, // 0 for neutral, not set
  company: {}, // contains alias, label and value
  rawData: {},
};

const getPolicyStageFromNo = (no) => {
  switch (no) {
    case 1:
      return LEAD;
    case 2:
      return QUOTE;
    case 3:
      return PROPOSAL;
    case 4:
      return POLICY;
    default:
      throw Error('no stage found');
  }
};

const getPolicyStageFromStr = (str) => {
  // str is based on backend value
  switch (str) {
    case 'lead':
      return LEAD;
    case 'quote':
      return QUOTE;
    case 'proposal':
      return PROPOSAL;
    case 'policy':
      return POLICY;
    case 'ckyc':
      return POLICY;
    case 'payment':
      return POLICY;

    default:
      throw Error('no stage found');
  }
};

export const txnSlice = createSlice({
  name: 'txn',
  initialState: initState,
  reducers: {
    UPDATE_TXN: (state, action) => {
      state = {
        ...state,
        [action.payload.id]: state[action.payload.data],
      };
    },
    UPDATE_LABEL: (state, action) => {
      state = {
        ...state,
        label: action.payload,
      };
      return state;
    },
    UPDATE_BUSINESS: (state, action) => {
      state.businessType = action.payload;
    },
    UPDATE_POLICY_STAGE: (state, action) => {
      state.stage = isNaN(action.payload)
        ? getPolicyStageFromStr(action.payload)
        : getPolicyStageFromNo(action.payload);
    },
    UPDATE_TXN_ID: (state, action) => {
      state = {
        ...state,
        transaction_id: action.payload,
      };
      return state;
    },
    UPDATE_QUOTE_ID: (state, action) => {
      state = {
        ...state,
        quote_id: action.payload,
      };
      return state;
    },
    UPDATE_COMPANY: (state, action) => {
      state = {
        ...state,
        company: action.payload,
      };
      return state;
    },
    UPDATE_RAW_DATA: (state, action) => {
      const { key, data } = action.payload;
      state = {
        ...state,
        rawData: {
          [key]: data,
        },
      };
      return state;
    },
    RESET_RAW_DATA: (state, data) => {
      state = {
        ...state,
        rawData: {},
      };
      return state;
    },
    RESET_TXN_STATE: () => initState,
  },
});

export const LEAD = 'lead';
export const QUOTE = 'quote';
export const PROPOSAL = 'proposal';
export const POLICY = 'policy';

export const {
  UPDATE_TXN,
  UPDATE_LABEL,
  UPDATE_BUSINESS,
  UPDATE_POLICY_STAGE,
  UPDATE_TXN_ID,
  UPDATE_QUOTE_ID,
  UPDATE_RAW_DATA,
  RESET_RAW_DATA,
  UPDATE_COMPANY,
  RESET_TXN_STATE,
} = txnSlice.actions;

export default txnSlice.reducer;
